import { AdminLayout } from '@/components/layouts'
import { useForm } from '@inertiajs/react'
import { UserForm } from './UserForm'

interface UserDetail {
  id: number
  name: string
  pseudo: string
  first_name: string
  last_name: string
  email: string
  rpps: string
  specialty: string
  role: string
  community_id: number
  community_name: string | null
  total_points: number
  level: number
  internal_account: boolean
  created_at: string
  updated_at: string
}

interface Community {
  id: number
  name: string
}

interface EditProps {
  user: UserDetail
  communities: Community[]
  specialties: string[]
  roles: string[]
}

export default function Edit({ user, communities, specialties, roles }: EditProps) {
  const { data, setData, patch, processing, errors } = useForm({
    pseudo: user.pseudo || '',
    first_name: user.first_name || '',
    last_name: user.last_name || '',
    email: user.email,
    rpps: user.rpps || '',
    specialty: user.specialty || '',
    role: user.role,
    community_id: String(user.community_id),
    password: '',
    password_confirmation: '',
    internal_account: user.internal_account || false
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    patch(`/admin/users/${user.id}`)
  }

  return (
    <AdminLayout
      title={`Modifier ${user.name}`}
      breadcrumbs={[
        { label: 'Utilisateurs', href: '/admin/users' },
        { label: user.name, href: `/admin/users/${user.id}` },
        { label: 'Modifier' }
      ]}
    >
      <UserForm
        data={data}
        setData={setData}
        errors={errors}
        processing={processing}
        onSubmit={handleSubmit}
        communities={communities}
        specialties={specialties}
        roles={roles}
        isEdit={true}
      />
    </AdminLayout>
  )
}
